import type { Player } from "."

export const getPlayerList = ({
  playerCount,
}: {
  playerCount: number
}): Player.Id[] => {
  return [...Array(playerCount).keys()] as Player.Id[]
}
